export const isNameValid = (name: string) => {
  return /^[a-zA-ZÀ-ÖØ-öø-ÿ ]+$/.test(name);
};
